import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ScheduleCollectiveEditCompleteTemplate } from 'components/Templates'

const ScheduleCollectiveEditComplete: FC = () => {
  return (
    <Layout title={`完了 | 商品の受渡日を一括設定`}>
      <ScheduleCollectiveEditCompleteTemplate />
    </Layout>
  )
}

export default ScheduleCollectiveEditComplete
